import React from "react";

import {
    FiBookOpen,
    FiCreditCard,
    FiFileText,
    FiTrendingDown,
} from "react-icons/fi";

import {
    formatCurrency,
    formatDate,
    formatType,
    getBalance,
    getCredit,
    getCustomerMobile,
    getCustomerName,
    getDebit,
    getDescription,
    getEntryDate,
    getEntryType,
    getReference,
} from "../utils/customerLedgerUtils";

/*
|--------------------------------------------------------------------------
| ENTRY ICON
|--------------------------------------------------------------------------
*/

const EntryIcon = ({
    type,
}) => {
    if (
        type.includes(
            "INVOICE"
        )
    ) {
        return (
            <FiFileText />
        );
    }

    if (
        type.includes(
            "PAYMENT"
        )
    ) {
        return (
            <FiCreditCard />
        );
    }

    if (
        type.includes(
            "CREDIT"
        )
    ) {
        return (
            <FiTrendingDown />
        );
    }

    return (
        <FiBookOpen />
    );
};

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const LedgerEntriesTable = ({
    records = [],
    loading = false,
}) => {
    if (
        loading &&
        records.length ===
            0
    ) {
        return (
            <div className="customer-ledger-table-loading">
                Loading ledger entries...
            </div>
        );
    }

    if (
        records.length ===
        0
    ) {
        return (
            <div className="customer-ledger-table-empty">
                <FiBookOpen />

                <h3>
                    No ledger entries found
                </h3>

                <p>
                    Invoice, payment and credit transactions will appear here.
                </p>
            </div>
        );
    }

    return (
        <div className="customer-ledger-table-wrapper">
            <table className="customer-ledger-table">
                <thead>
                    <tr>
                        <th>
                            Date
                        </th>

                        <th>
                            Customer
                        </th>

                        <th>
                            Transaction
                        </th>

                        <th>
                            Reference
                        </th>

                        <th>
                            Description
                        </th>

                        <th className="text-right">
                            Debit
                        </th>

                        <th className="text-right">
                            Credit
                        </th>

                        <th className="text-right">
                            Balance
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {records.map(
                        (
                            row,
                            index
                        ) => {
                            const type =
                                getEntryType(
                                    row
                                );

                            const debit =
                                getDebit(
                                    row
                                );

                            const credit =
                                getCredit(
                                    row
                                );

                            return (
                                <tr
                                    key={
                                        row?._id ||
                                        row?.id ||
                                        `${type}-${index}`
                                    }
                                >
                                    <td>
                                        <span className="customer-ledger-date">
                                            {formatDate(
                                                getEntryDate(
                                                    row
                                                )
                                            )}
                                        </span>
                                    </td>

                                    <td>
                                        <div className="customer-ledger-customer-cell">
                                            <span className="customer-ledger-customer-avatar">
                                                {String(
                                                    getCustomerName(
                                                        row
                                                    )
                                                )
                                                    .charAt(
                                                        0
                                                    )
                                                    .toUpperCase()}
                                            </span>

                                            <div>
                                                <strong>
                                                    {getCustomerName(
                                                        row
                                                    )}
                                                </strong>

                                                <small>
                                                    {getCustomerMobile(
                                                        row
                                                    )}
                                                </small>
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <span
                                            className={`customer-ledger-type customer-ledger-type-${type
                                                .toLowerCase()
                                                .replace(
                                                    /_/g,
                                                    "-"
                                                )}`}
                                        >
                                            <EntryIcon
                                                type={
                                                    type
                                                }
                                            />

                                            {formatType(
                                                type
                                            )}
                                        </span>
                                    </td>

                                    <td>
                                        <strong className="customer-ledger-reference">
                                            {getReference(
                                                row
                                            )}
                                        </strong>
                                    </td>

                                    <td>
                                        <span className="customer-ledger-description">
                                            {getDescription(
                                                row
                                            )}
                                        </span>
                                    </td>

                                    <td className="text-right">
                                        <strong className="customer-ledger-debit">
                                            {debit >
                                            0
                                                ? formatCurrency(
                                                      debit
                                                  )
                                                : "-"}
                                        </strong>
                                    </td>

                                    <td className="text-right">
                                        <strong className="customer-ledger-credit">
                                            {credit >
                                            0
                                                ? formatCurrency(
                                                      credit
                                                  )
                                                : "-"}
                                        </strong>
                                    </td>

                                    <td className="text-right">
                                        <strong className="customer-ledger-balance">
                                            {formatCurrency(
                                                getBalance(
                                                    row
                                                )
                                            )}
                                        </strong>
                                    </td>
                                </tr>
                            );
                        }
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LedgerEntriesTable;